module.exports = __webpack_public_path__ + "709af29ea5ca52fa8e54d82fccc10f52.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KY.svg
// module id = iwtG
// module chunks = 0